import { Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { atoms } from 'atoms';
import { useAtomValue } from 'jotai/utils';
import { useTranslation } from 'react-i18next';
import { defaultSorter } from 'utilities/default-sorter';
import { displayWithDecimals } from 'utilities/displayWithDecimals';
import { roundToDecimals } from 'utilities/roundToDecimals';

const format = (value) =>
  value === undefined || value === null
    ? ''
    : displayWithDecimals(2)(roundToDecimals(2)(value));

export const SubfieldPlanned = ({ yearlyOverview }) => {
  const { t } = useTranslation();
  const plots = useAtomValue(atoms.plots);

  const InitColumns = [
    {
      id: 'subfieldId',
      render: (subfieldId, record) =>
        plots.find((z) => z.id === record.subFieldId)?.properties?.name,
      sorter: (a, b) => {
        const aName = plots.find((z) => z.id === a.subFieldId)?.properties
          ?.name;
        const bName = plots.find((z) => z.id === b.subFieldId)?.properties
          ?.name;

        return defaultSorter((name: string) => name)(aName, bName);
      },
      sortOrder: 'ascend',
      sortDirections: ['ascend'],
    },
    { id: 'hectare', render: format },
    { id: 'm3ManurePerHectare', render: format },
    { id: 'kgWorkingNitrogenPerHectareFromManure', render: format },
    { id: 'kgPhosphatePerHectareFromManure', render: format },
    { id: 'kgNitrogenPerHectareFromFertilizer', render: format },
    { id: 'kgNitrogenTotalPerHectare', render: format },
    { id: 'm3ManureRealizedPerHectare', render: format },
    { id: 'kgNitrogenPerHectareFromFertilizerRealized', render: format },
  ];

  const columns = InitColumns.map((c) => ({
    title: t(`yearlyoverview.${c.id}`),
    dataIndex: c.id,
    key: c.id,
    render: c.render,
    sorter: c.sorter,
    sortOrder: c.sortOrder,
    sortDirections: c.sortDirections,
  })) as ColumnsType<any>;

  // yearlyOverview.annualReviewPerSubfieldsPlanned
  return (
    <Table
      loading={!yearlyOverview}
      dataSource={yearlyOverview?.annualReviewPerSubfieldsPlanned}
      columns={columns}
      scroll={{ x: true }}
    ></Table>
  );
};
